module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJUAAAANCAYAAACglyxhAAAACXBIWXMAAAsTAAALEwEAmpwYAAABCUlEQVRYhe3YIU4DQRQA0FeyCQmCO2AIAkWC4QgEW1RJQGG4AgaOQDBYUgMGU05QQyBg8EgsAoErYtxuF7bbLbSb/5IxM/MnX/z8zEyndzboGu8dw+vT3ZLlEMbLcFOyNsDeH+YSWmLpvxMI7RNFFRoXRRUal1XZdHB+P+s8wgIqe8RluC2JeZ5ZNqEVyppNhv0JzjnEJVamTynMsTsc4aPC3lF+ojMaFeYKchW5KXW3jSrZhYX1JjWcp1/2FQqozkX9Fdvo14gNi2MNQ5xMGlj39feJHo7xVfOMMP+WcSF9kK9WDZr2S+EKO1KrDO3VxaN09cnr5EcT/1Qv2JIud6G91vEgPdZ+9A0e8SbDaD/EzwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/title-bottom2.png
// module id = /yvk
// module chunks = 0